import { render, staticRenderFns } from "./VendorRegistrationForm.vue?vue&type=template&id=6618cfe1&scoped=true"
import script from "./VendorRegistrationForm.vue?vue&type=script&lang=js"
export * from "./VendorRegistrationForm.vue?vue&type=script&lang=js"
import style0 from "./VendorRegistrationForm.vue?vue&type=style&index=0&id=6618cfe1&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6618cfe1",
  null
  
)

export default component.exports